var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collect-card-list" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticClass: "collect-card-list-wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form-inline",
                  attrs: { model: _vm.ruleForm, inline: true, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领卡ID" } },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "id", $$v)
                          },
                          expression: "ruleForm.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡类型", prop: "card_type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.changeCardType },
                          model: {
                            value: _vm.ruleForm.card_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "card_type", $$v)
                            },
                            expression: "ruleForm.card_type",
                          },
                        },
                        _vm._l(_vm.cardTypeList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: Number(item.id) },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "领卡人", prop: "sale_user_id\t" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: {
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "remote-method": _vm.searchReceiver,
                            loading: _vm.personLoading,
                            "no-data-text": "无数据",
                            placeholder: "请选择",
                          },
                          on: {
                            clear: function ($event) {
                              return _vm.searchReceiver("")
                            },
                          },
                          model: {
                            value: _vm.ruleForm.sale_user_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "sale_user_id", $$v)
                            },
                            expression: "ruleForm.sale_user_id",
                          },
                        },
                        _vm._l(
                          _vm.personOptions.receiver || [],
                          function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: _vm.formatPersonLabel(item),
                                value: item.id,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "组织", prop: "organize_id" } },
                    [
                      _c("el-cascader", {
                        ref: "organize",
                        staticClass: "input__width",
                        attrs: {
                          options: _vm.options,
                          "collapse-tags": "",
                          props: {
                            label: "label",
                            value: "value",
                            children: "children",
                            multiple: true,
                            emitPath: false,
                          },
                          clearable: "",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.ruleForm.organize_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "organize_id", $$v)
                          },
                          expression: "ruleForm.organize_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物料类型", prop: "material_type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.changeCardType },
                          model: {
                            value: _vm.ruleForm.material_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "material_type", $$v)
                            },
                            expression: "ruleForm.material_type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "PVC卡", value: 1 },
                          }),
                          _c("el-option", { attrs: { label: "券", value: 2 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户ID" } },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.customer_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "customer_id", $$v)
                          },
                          expression: "ruleForm.customer_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "领卡状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        _vm._l(_vm.collectStatus, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "异常处理状态",
                        prop: "exception_status",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.ruleForm.exception_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "exception_status", $$v)
                            },
                            expression: "ruleForm.exception_status",
                          },
                        },
                        _vm._l(_vm.exceptionStatus, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "领卡天数" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.begin_days,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "begin_days", $$v)
                          },
                          expression: "ruleForm.begin_days",
                        },
                      }),
                      _vm._v(" - "),
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.end_days,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "end_days", $$v)
                          },
                          expression: "ruleForm.end_days",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "领卡日期", prop: "date_arr" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTime($event, 3)
                          },
                        },
                        model: {
                          value: _vm.ruleForm.date_arr,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "date_arr", $$v)
                          },
                          expression: "ruleForm.date_arr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间", prop: "create_data_arr" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTime($event, 2)
                          },
                        },
                        model: {
                          value: _vm.ruleForm.create_data_arr,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "create_data_arr", $$v)
                          },
                          expression: "ruleForm.create_data_arr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "预计领卡日期",
                        prop: "expected_date_arr",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTime($event, 1)
                          },
                        },
                        model: {
                          value: _vm.ruleForm.expected_date_arr,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "expected_date_arr", $$v)
                          },
                          expression: "ruleForm.expected_date_arr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡序号段" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "190px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.begin_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "begin_code", $$v)
                          },
                          expression: "ruleForm.begin_code",
                        },
                      }),
                      _vm._v(" - "),
                      _c("el-input", {
                        staticStyle: { width: "190px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.end_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "end_code", $$v)
                          },
                          expression: "ruleForm.end_code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            type: "primary",
                            loading: _vm.submitLoading,
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.submitLoading },
                          on: { click: _vm.resetForm },
                        },
                        [_vm._v("重置")]
                      ),
                      _vm.$hasBtnRoles("/orders/card-management/create")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.submitLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleReceiveRegister("add")
                                },
                              },
                            },
                            [_vm._v("领卡登记")]
                          )
                        : _vm._e(),
                      _vm.$hasBtnRoles("/orders/card-management/demand-create")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.submitLoading,
                              },
                              on: { click: _vm.handleDemandApply },
                            },
                            [_vm._v("领卡需求登记")]
                          )
                        : _vm._e(),
                      _vm.$hasBtnRoles("/orders/card-management/export") &&
                      _vm.tab_type == 0
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportLoading,
                              },
                              on: { click: _vm.getCardManagementExport },
                            },
                            [_vm._v("导出")]
                          )
                        : _vm._e(),
                      _vm.$hasBtnRoles(
                        "/orders/card-management/exception-export"
                      ) && _vm.tab_type == 1
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportLoading,
                              },
                              on: {
                                click: _vm.getCardManagementExcptionExport,
                              },
                            },
                            [_vm._v("导出")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "table",
              staticStyle: { "padding-bottom": "100px" },
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    "header-cell-style": {
                      background: "#F1F1F1",
                      color: "#333333",
                    },
                    data: _vm.dataList,
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "领卡ID", prop: "id", width: "70" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "卡信息", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.card_group_type_name || "-"
                                  ) +
                                  "："
                              ),
                              _c("span", [
                                _vm._v(_vm._s(scope.row.card_type_name || "-")),
                              ]),
                            ]),
                            scope.row.material_id != 0
                              ? _c("div", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(scope.row.material_id) +
                                      ") " +
                                      _vm._s(scope.row.material_name)
                                  ),
                                ])
                              : _vm._e(),
                            _c("div", [
                              _vm._v(
                                "物料类型： " +
                                  _vm._s(scope.row.material_type_cn)
                              ),
                            ]),
                            _c("div", [
                              _vm._v("起：" + _vm._s(scope.row.begin_code)),
                            ]),
                            _c("div", [
                              _vm._v("止：" + _vm._s(scope.row.end_code)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销售信息", "min-width": "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "领卡人：" + _vm._s(scope.row.sale_user_name)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "组织：" + _vm._s(scope.row.organize_name)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                " 客户ID：" +
                                  _vm._s(scope.row.customer_id) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "申请时间：" + _vm._s(scope.row.created_time)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "领卡信息", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                " 预计领卡日期：" +
                                  _vm._s(scope.row.expected_card_date) +
                                  " " +
                                  _vm._s(scope.row.expected_card_time) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                " 领卡日期：" +
                                  _vm._s(scope.row.card_date) +
                                  " " +
                                  _vm._s(scope.row.card_time) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "领卡天数：" + _vm._s(scope.row.receive_day)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "经办人：" + _vm._s(scope.row.perator_user_name)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "卡状态", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "card-status-item" }, [
                              _c("span", { staticStyle: { width: "100%" } }, [
                                _vm._v(
                                  " 卡数量：" + _vm._s(scope.row.number) + " "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "card-status-item" }, [
                              _c(
                                "span",
                                {
                                  style: {
                                    color:
                                      scope.row.not_sale_number != 0
                                        ? "red"
                                        : "#606266",
                                  },
                                },
                                [
                                  _vm._v(
                                    "待售：" + _vm._s(scope.row.not_sale_number)
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  style: {
                                    color:
                                      scope.row.not_activated_number != 0
                                        ? "red"
                                        : "#606266",
                                  },
                                },
                                [
                                  _vm._v(
                                    "待激活：" +
                                      _vm._s(scope.row.not_activated_number)
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "card-status-item" }, [
                              _c(
                                "span",
                                {
                                  style: {
                                    color:
                                      scope.row.review_number != 0
                                        ? "red"
                                        : "#606266",
                                  },
                                },
                                [
                                  _vm._v(
                                    "审核中：" + _vm._s(scope.row.review_number)
                                  ),
                                ]
                              ),
                              _c("span", [
                                _vm._v(
                                  "已激活：" +
                                    _vm._s(scope.row.activated_number)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "card-status-item" }, [
                              _c("span", [
                                _vm._v(
                                  "已冻结：" + _vm._s(scope.row.frozen_number)
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  "清余额：" +
                                    _vm._s(scope.row.clear_balance_number)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "card-status-item" }, [
                              _c("span", [
                                _vm._v(
                                  "已作废：" + _vm._s(scope.row.delete_number)
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "关联其他物料申请单", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.other_material_receive_code
                              ? _c(
                                  "div",
                                  [
                                    _vm._v(" 单号："),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goReceiveId(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row
                                              .other_material_receive_code
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "处理状态", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "领卡状态：" + _vm._s(scope.row.status_cn)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "异常处理状态：" +
                                  _vm._s(scope.row.exception_status_cn)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      width: "50",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.$hasBtnRoles(
                              "/orders/card-management/receive"
                            ) && scope.row.status == 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleReceiveRegister(
                                              "receive",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 领取")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.$hasBtnRoles("/orders/card-management/view")
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toDetail(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("详情")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.$hasBtnRoles(
                              "/orders/card-management/delete"
                            ) &&
                            scope.row.status != 2 &&
                            _vm.tab_type == 0 &&
                            scope.row.status != "1"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toCancel(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "pagination__style",
            attrs: {
              background: "",
              total: _vm.pages.totalCount,
              "page-size": 20,
              layout: "total, prev, pager, next, jumper",
              "current-page": _vm.pages.currentPage,
            },
            on: { "current-change": _vm.onChange },
          }),
          _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerDetail,
                size: "88%",
                "custom-class": "myDrawer",
                title: "领卡详情",
                "destroy-on-close": "",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerDetail = $event
                },
              },
            },
            [
              _c("collect-card-detail", {
                attrs: { id: _vm.currentDetailId },
                on: {
                  close: function ($event) {
                    _vm.drawerDetail = false
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerDemand,
                size: "88%",
                "custom-class": "myDrawer",
                title: "领卡需求登记",
                "destroy-on-close": "",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerDemand = $event
                },
              },
            },
            [
              _c("CardDemandApplyDrawer", {
                on: {
                  close: function ($event) {
                    _vm.drawerDemand = false
                  },
                  emitGetList: _vm.handleDemandEmitGetList,
                },
              }),
            ],
            1
          ),
          _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerReceive,
                size: "88%",
                "custom-class": "myDrawer",
                title: _vm.receiveMode === "edit" ? "领卡记录编辑" : "领卡登记",
                "destroy-on-close": "",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerReceive = $event
                },
              },
            },
            [
              _c("CardReceiveRegisterDrawer", {
                attrs: { row: _vm.receiveRow, mode: _vm.receiveMode },
                on: {
                  close: function ($event) {
                    _vm.drawerReceive = false
                  },
                  emitGetList: _vm.handleReceiveEmitGetList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }